<template>
  <w-modal
    v-model="show"
    class="modal-big payment-details"
    close-button="Anuluj"
    submit-button="Ok"
    :title="title"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    :show-close-button="false"
    :show-submit-button="!isEditing"
    :show-footer="false"
    @submit="close"
    @close="close"
  >
    <div v-if="!isEditing" class="row">
      <div class="form-group col-12 table-responsive">
        <table class="table table-bordered table-striped w-100">
          <thead>
            <tr class="w-table-row">
              <th />

              <th class="data-header">Dane ze zobowiązania</th>

              <th class="data-header">Dane z aktualnej dokumentacji</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(field, index) of fields" :key="'field_' + index">
              <th>{{ field.displayName }}</th>

              <td v-html="getPaymentValue(field)" />

              <td v-html="getDocumentValue(field)" />
            </tr>

            <tr v-if="stateData && stateData.data && !ksatDisabled">
              <th>ID kontrahenta KSAT</th>

              <td>{{ stateData.data.contractorId }}</td>

              <td />
            </tr>

            <tr v-if="stateData && stateData.data && !ksatDisabled">
              <th>ID adresu KSAT</th>

              <td>{{ stateData.data.contractorAddressId }}</td>

              <td />
            </tr>

            <tr v-if="stateData && stateData.data && !ksatDisabled">
              <th>ID konta bankowego KSAT</th>

              <td>{{ stateData.data.contractorBankAccountId }}</td>

              <td />
            </tr>
          </tbody>

          <tfoot v-if="showUpdateOptions">
            <tr>
              <td />

              <td>
                <check-permission
                  permission="PAYMENT.UPDATE"
                  entity-type="payment"
                  :entity-id="stateData && stateData.id"
                >
                  <w-button class="btn-warning" text="Edytuj dane zobowiązania" @click="edit" />
                </check-permission>

                <check-permission
                  v-if="!ksatDisabled"
                  permission="PAYMENT.UPDATE"
                  entity-type="payment"
                  :entity-id="stateData && stateData.id"
                >
                  <w-button class="btn-danger ml-3" text="Waliduj dane w KSAT" @click="update" />
                </check-permission>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <ksat-payment-details-edit v-else-if="!ksatDisabled" @close="closeEdit" />

    <ko-payment-details-edit v-else @close="closeEdit" />
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import { PaymentState } from '@/enums/paymentState';
import { PublicSettings } from '@/enums/publicSettings.enum';
import { modalMixin } from '@/mixins/modal';
import { notificationsMixin } from '@/mixins/notifications';
import { getColumnValue } from '@/utils/getColumnValue';

import KoPaymentDetailsEdit from './paymentDetailsModal/KoPaymentDetailsEdit.vue';
import KsatPaymentDetailsEdit from './paymentDetailsModal/KsatPaymentDetailsEdit.vue';

// @vuese
// Modal dodania
// @group Modals
export default {
  components: { KoPaymentDetailsEdit, KsatPaymentDetailsEdit },
  mixins: [notificationsMixin, modalMixin],
  data() {
    return { isEditing: false, PaymentState };
  },
  computed: {
    ...mapState({
      stateData: state => state.payment.data,
      ksatDisabled: state => state.setting.settings[PublicSettings.KSAT_DISABLED]?.value === 'true',
      columns: state => JSON.parse(state.setting.settings[PublicSettings.PAYMENT_COLUMNS].value),
      documentIndex: state => state.documentIndex.data
    }),
    title() {
      return 'Zobowiązanie ' + this.stateData?.number;
    },
    fields() {
      return this.columns.filter(column => column.name !== 'index');
    },
    showUpdateOptions() {
      if (this.ksatDisabled) {
        return (
          this.stateData?.pack.status === PaymentState.NOT_SENT ||
          this.stateData?.pack.status === PaymentState.UNCONFIRMED ||
          this.stateData?.pack.status === PaymentState.KO_SENT ||
          this.stateData?.pack.status === PaymentState.RECEIVED_FUNDS
        );
      }
      return (
        this.stateData &&
        (this.stateData.state === PaymentState.NOT_SENT || this.stateData.state === PaymentState.CONTRACTOR_FAILURE)
      );
    }
  },
  methods: {
    // @vuese
    // Zwraca wartość z obiektu płatności
    getPaymentValue(field) {
      return getColumnValue(this.stateData, field, {
        fieldWithPath: 'paymentName',
        fieldWithTransformer: 'paymentNameTransformer'
      });
    },

    // @vuese
    // Zwraca wartość z dokumentu
    getDocumentValue(field) {
      return getColumnValue(this.documentIndex, field);
    },

    // @vuese
    // Emituje event o konieczności aktualizacji danych kontrahenta KSAT
    update() {
      this.$emit('update', { id: this.stateData?.id });
    },

    // @vuese
    // Otwiera edycję danych płatności
    edit() {
      this.isEditing = true;
    },

    // @vuese
    // Zamyka edycję danych płatności
    closeEdit() {
      this.isEditing = false;
    }
  }
};
</script>

<style>
.payment-details.modal-big .modal-content {
  height: auto;
}

.payment-details .table tbody th {
  vertical-align: bottom;
  border-bottom: none;
  background-color: #dcdcdc;
  color: black;
  text-align: center;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 0.8rem;
  padding: 0.6rem;
}

.payment-details .table tfoot td {
  border: none;
}

.payment-details .table th.data-header {
  width: 50%;
}
</style>
